module.exports = __webpack_public_path__ + "static/moonamar-balsamo-para-piel-con-argan-y-comino-negro-2cc7cdfd9c3312cadb13eebb33c1f1a4.png";